import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/extensions
import { FacebookProvider } from 'react-facebook/dist/cjs/index.js';

import { getAccountInitials, getAvatarColor } from '../../../utils/recentAccounts';
import { GoogleSignInButton } from '../GoogleSignInButton';
import { FacebookSignInButton } from '../FacebookSignInButton';
import {
  ContinueOtherAccountBtn,
  RecentAccountAvatar,
  RecentAccountEmail,
  RecentAccountInfo,
  RecentAccountItem,
  RecentAccountName,
  RecentAccountRow,
  RecentAccountRowContent,
  RecentAccountsDivider,
  RecentAccountsListContainer,
  RecentAccountsTitle,
  RecentAccountsWrapper,
  RemoveAccountsButton,
} from './styles';

function AccountDetails({ account }) {
  return (
    <>
      <RecentAccountAvatar $color={getAvatarColor(account.email)}>
        {getAccountInitials(account.name, account.email)}
      </RecentAccountAvatar>
      <RecentAccountInfo>
        <RecentAccountName>{account.name}</RecentAccountName>
        <RecentAccountEmail>{account.email}</RecentAccountEmail>
      </RecentAccountInfo>
    </>
  );
}

function RecentAccountEntry({
  account,
  onFacebookCompleted,
  onMicrosoftLogin,
  onAppleLogin,
  onSelectAccount,
}) {
  const { provider } = account;

  if (provider === 'google') {
    return (
      <RecentAccountRow>
        <RecentAccountRowContent>
          <AccountDetails account={account} />
        </RecentAccountRowContent>
        <GoogleSignInButton overlay loginHint={account.email} />
      </RecentAccountRow>
    );
  }

  if (provider === 'facebook') {
    return (
      <RecentAccountRow>
        <RecentAccountRowContent>
          <AccountDetails account={account} />
        </RecentAccountRowContent>
        <FacebookSignInButton overlay onFacebookCompleted={onFacebookCompleted} />
      </RecentAccountRow>
    );
  }

  if (provider === 'microsoft') {
    return (
      <RecentAccountItem type="button" onClick={() => onMicrosoftLogin(account.email)}>
        <AccountDetails account={account} />
      </RecentAccountItem>
    );
  }

  if (provider === 'apple') {
    return (
      <RecentAccountItem type="button" onClick={onAppleLogin}>
        <AccountDetails account={account} />
      </RecentAccountItem>
    );
  }

  return (
    <RecentAccountItem type="button" onClick={() => onSelectAccount(account)}>
      <AccountDetails account={account} />
    </RecentAccountItem>
  );
}

export function RecentAccountsList({
  accounts,
  onSelectAccount,
  onContinueOther,
  onRemoveAccounts,
  onFacebookCompleted,
  onMicrosoftLogin,
  onAppleLogin,
}) {
  const { t } = useTranslation();
  const hasFacebookAccount = accounts.some((account) => account.provider === 'facebook');

  if (!accounts?.length) {
    return null;
  }

  const list = (
    <RecentAccountsListContainer>
      {accounts.map((account) => (
        <RecentAccountEntry
          key={`${account.provider}-${account.email}`}
          account={account}
          onSelectAccount={onSelectAccount}
          onFacebookCompleted={onFacebookCompleted}
          onMicrosoftLogin={onMicrosoftLogin}
          onAppleLogin={onAppleLogin}
        />
      ))}
    </RecentAccountsListContainer>
  );

  return (
    <RecentAccountsWrapper>
      <RecentAccountsTitle
        dangerouslySetInnerHTML={{ __html: t('signin.recent-accounts.title') }}
      />

      {hasFacebookAccount ? (
        <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_ID}>{list}</FacebookProvider>
      ) : (
        list
      )}

      <RecentAccountsDivider>{t('signin.recent-accounts.divider')}</RecentAccountsDivider>

      <ContinueOtherAccountBtn type="button" onClick={onContinueOther}>
        {t('signin.recent-accounts.continue-other')}
      </ContinueOtherAccountBtn>

      <RemoveAccountsButton type="button" onClick={onRemoveAccounts}>
        {t('signin.recent-accounts.remove')}
      </RemoveAccountsButton>
    </RecentAccountsWrapper>
  );
}
